import { cx } from '@linaria/core';
import { ReactNode, useId, useRef, useState } from 'react';
import ChevronDown from '../Icons/ChevronDown';
import { fieldFullWidthStyles, fieldLabelStyles, fieldShrunkLabelStyles, fieldStyles, selectBoxedStyles, selectStyles, selectUnderlineLabelledStyles, selectUnderlineStyles } from './fieldStyles';
import Menu from './Menu';
import MenuItem from './MenuItem';
import "./PopoverSelect.linaria.module.css!=!./PopoverSelect?./PopoverSelect.linaria.module.css?css=H4sIAAAAAAAAA23OXW6FIBAF4PeuohvAFG/9uXQxhAsjoAiIo6hN997cJjax6etkvnNOIXDkh2/X94FT3LJd3WvRWXCKWB8X/FR2jk7srHOwfXy9FM//+h7W4+DU1KFfjn9O1wjhrPbEIowzk+AR0hmkbs1CG06rdco5XVVYIXUuZGasUuBPYu5vo+s4hcpMs7gShA3JTxtz0OFJ3K1pK8npdJdS/9mWjUUgcxQSmA85iXgqCuUu4sC123M3XtVDyEGnsHjFfPDwS+qqVMPGaV+2/VZeDcnwGCwSFJEYq42z2iCRwYXEMAk/R5HAP0d/Axl+NDuUAQAA"

/* the display is a button, not a select, so it needs a select's alignment back */
const displayStyles = "atm_zn8v4k_1txwivl atm_69ovzz_1h6ojuz atm_d37u17_15vqwwr atm_h90mlf_1e5hqsa atm_l3785c_1q9ccgz atm_1e2yapk_glywfm atm_1652dkx_1j28jx2";
export interface PopoverSelectOption {
  'data-testid'?: string;
  disabled?: boolean;
  label: ReactNode;
  value: string;
}
export interface PopoverSelectProps {
  className?: string;
  'data-testid'?: string;
  disabled?: boolean;
  /** what the closed field shows; defaults to the selected option's label */
  display?: ReactNode;
  fullWidth?: boolean;
  label?: ReactNode;
  /** lands on the menu paper, for sizing the open list */
  menuClassName?: string;
  name?: string;
  onChange(value: string): void;
  options: PopoverSelectOption[];
  underline?: boolean;
  value: string;
}
const PopoverSelect = (props: PopoverSelectProps) => {
  const {
    className,
    disabled = false,
    display,
    fullWidth = false,
    label,
    menuClassName,
    name,
    onChange,
    options,
    underline = false,
    value,
    'data-testid': dataTestId
  } = props;
  const controlRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const selectId = useId();
  const hasLabel = label !== undefined && label !== null;
  const selected = options.find(option => option.value === value);
  const shown = display === undefined ? selected?.label : display;
  return <div className={cx('mfc-popover-select', fieldStyles, selectStyles, displayStyles, !underline && selectBoxedStyles, hasLabel && fieldLabelStyles, !underline && hasLabel && fieldShrunkLabelStyles, underline && selectUnderlineStyles, underline && hasLabel && selectUnderlineLabelledStyles, fullWidth && fieldFullWidthStyles, className)} data-testid={dataTestId}>
            <div className="field-control" ref={controlRef}>
                <button aria-expanded={open} aria-haspopup="listbox" className="field-input" disabled={disabled} id={selectId} onClick={() => setOpen(true)} type="button">
                    {shown}
                </button>
                {hasLabel && <label className="field-label" htmlFor={selectId}>
                        {label}
                    </label>}
                <ChevronDown className="field-chevron" data-testid="Select__Chevron" size={0.9} />
                {!underline && <fieldset aria-hidden="true" className="field-outline">
                        <legend>
                            <span>{hasLabel ? label : '​'}</span>
                        </legend>
                    </fieldset>}
                {/* carries the value for form reads and E2E, like MUI's did */}
                <input name={name} type="hidden" value={value} />
            </div>
            <Menu anchorEl={controlRef.current} anchorOrigin={{
      vertical: 'top',
      horizontal: 'left'
    }} className={menuClassName} matchAnchorWidth onClose={() => setOpen(false)} open={open} role="listbox" transformOrigin={{
      vertical: 'top',
      horizontal: 'left'
    }}>
                {options.map(option => <MenuItem data-testid={option['data-testid']} disabled={option.disabled} key={option.value} onClick={() => onChange(option.value)} role="option" selected={option.value === value}>
                        {option.label}
                    </MenuItem>)}
            </Menu>
        </div>;
};
export default PopoverSelect;